<template>
  <svg :class="['icon', icon]">
    <use :xlink:href="`#${icon}`" />
  </svg>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      default: ''
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../scss/base/colors';

.icon {
  min-width: 1em;
  min-height: 1em;
  max-width: 1em;
  max-height: 1em;
  color: inherit;
  fill: currentColor;
}

.size-size-_7em {
  font-size: 0.7em;
}

.size-2em {
  font-size: 2em;
}

.size-3em {
  font-size: 3em;
}

.size-4em {
  font-size: 4em;
}

.drop-arrow {
  transform: rotate(90deg);
}
</style>
